module.exports = __webpack_public_path__ + "img/kv-left-top.95b11aaf.png";